// Accessibility "fixes"
const quantityInput = document.querySelector('.koala-deal__quantity-input')
if (quantityInput) {
    const screenReaderLabel = document.createElement('span')
    screenReaderLabel.className = 'sr-only'
    screenReaderLabel.textContent = 'Select quantity'
    quantityInput.parentNode.insertBefore(screenReaderLabel, quantityInput) 
}

const thumbnailsSplideEl = document.querySelector('.splide--thumbnails')
if (thumbnailsSplideEl) {
    setTimeout(() => {
        const vertThumbnailList = document.querySelector('[aria-orientation="vertical"]')
        if (vertThumbnailList) {
            vertThumbnailList.removeAttribute('aria-orientation')
        }
    }, 3000)
}